import {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {Trans, useTranslation} from 'react-i18next';
import SubSettingItem from '../subSettingItem/SubSettingItem';
import SubSettingForm from '../subSettingForm/SubSettingForm';
import ModeBtn, {statuses} from '../../../component/modeBtn/ModeBtn';
import useShow from '../../../hooks/useShow';
import {updateEventSettings} from '../../../redux/event/eventActions';
import {LIVE_DOMAIN} from '../../../config/config';

import * as css from '../settingItem/SettingItem.css';

import * as localCss from './PromotionInLiveSetting.css';

const PROMOTED_UI_SCOPES = ['homePage', 'category', 'area', 'city', 'tag', 'venue'];

const scopeLabelKey = (scope) => `promotedScope${scope.charAt(0).toUpperCase()}${scope.slice(1)}`;

export function AutoPromotionBanner() {

    const eid = useSelector(s => s.event.eid);

    const promotionEventActive = useSelector(s => s.event.settings?.event?.promotionEventActive);

    if(!promotionEventActive) {

        return null;

    }

    const editUrl = `${LIVE_DOMAIN}/livePlus?section=promotion&eid=${eid}`;

    return (

        <localCss.banner data-cy="autoPromotionBanner">

            <Trans

                i18nKey="event:autoPromotionBannerFull"

                components={{

                    editLink: (

                        <localCss.bannerLink

                            href={editUrl}

                            target="_blank"

                            rel="noopener noreferrer"

                            data-cy="autoPromotionEditLink"

                        />

                    )

                }}

            />

        </localCss.banner>

    );

}

function PromotionInLiveSetting() {

    const {t} = useTranslation('event');

    const promotedScopes = useSelector(s => s.event.settings?.event?.promotedScopes) || [];

    const promotionEventActive = useSelector(s => s.event.settings?.event?.promotionEventActive);

    const hasLiveEntity = useSelector(s => s.event.settings?.event?.hasLiveEntity);

    const settingXHR = useSelector(s => s.forms.eventSettings.promotedScopesXHR);

    const expandShow = useShow();

    const isFirstRun = useRef(true);

    useEffect(() => {

        if(isFirstRun.current) {

            isFirstRun.current = false;

            if(promotedScopes.length > 0) {

                expandShow.open();

            }

        }

    }, [promotedScopes.length]);

    if(promotionEventActive) {

        return null;

    }

    const isActive = promotedScopes.length > 0;

    const saveScopes = (nextScopes) => {

        updateEventSettings('promotedScopes', nextScopes, 'event');

    };

    const toggleMode = () => {

        if(isActive) {

            saveScopes([]);

            expandShow.close();

            return;

        }

        expandShow.isOpen ? expandShow.close() : expandShow.open();

    };

    const toggleScope = (scope, checked) => {

        const nextScopes = checked

            ? [...promotedScopes, scope]

            : promotedScopes.filter(item => item !== scope);

        saveScopes(nextScopes);

        if(nextScopes.length && !expandShow.isOpen) {

            expandShow.open();

        }

    };

    return (

        <>

            <SubSettingItem text={t('promotionInLive')}>

                <css.toggle>

                    <ModeBtn

                        click={toggleMode}

                        status={isActive ? statuses.active : statuses.inactive}

                        requestStatus={settingXHR}

                        disabled={hasLiveEntity === false}

                        dataCyName="promotionInLive"

                    />

                </css.toggle>

            </SubSettingItem>

            {hasLiveEntity === false && (

                <localCss.disabledNote>{t('livePromotionNoEntity')}</localCss.disabledNote>

            )}

            {expandShow.isOpen && hasLiveEntity !== false && (

                <SubSettingForm className={expandShow.showClass} name="promotionInLive">

                    <localCss.scopeList>

                        {PROMOTED_UI_SCOPES.map((scope) => (

                            <localCss.scopeRow key={scope}>

                                <input

                                    type="checkbox"

                                    checked={promotedScopes.includes(scope)}

                                    data-cy={`promotion-scope-${scope}-checkbox`}

                                    onChange={(e) => toggleScope(scope, e.target.checked)}

                                />

                                {t(scopeLabelKey(scope))}

                            </localCss.scopeRow>

                        ))}

                    </localCss.scopeList>

                </SubSettingForm>

            )}

        </>

    );

}

export default PromotionInLiveSetting;

